/* eslint react/prop-types: off */
import React from 'react'
import Select from 'react-select'
import axios from 'axios'
import moment from 'moment-timezone'
import { flatten, include, isNull, includes, orderBy, some, capitalize, replace, filter, map, isEmpty, isNil, find, get } from 'lodash'
import { Alert, ContentSectionBlock, DetailList, FormInputText, FormInputTextArea, FormInputDate, FormInputCheckbox } from 'camino-react'

import Modal from 'Components/Modal'
import ErrorList from 'Components/ErrorList'
import LoadingSpinner from 'Components/LoadingSpinner'
import TextFieldSkeleton from 'Components/Skeletons/TextFieldSkeleton'
import ServiceCategories from 'Components/Tickets/Form/Sections/Services/ServiceCategories'
import Tags from 'Components/Tables/Ticket/Tags'
import TicketDescription from './TicketDescription'
import ClientFormFields from "Components/Tickets/Details/ClientFormFields";

import StringManipulator from 'Utilities/StringManipulator'
import { csrfToken } from 'Utilities/Csrf'
import { cloudhelpGet } from 'Utilities/CloudHelp'

export default class TicketDetailsTicketInformation extends React.Component {
  constructor (props) {
    super(props)

    const { ticket, statusIds } = props

    this.state = {
      ticket,
      showEditModal: false,
      title: ticket.title || '',
      description: ticket.description || '',
      service_category_id: ticket.service_category_id || '',
      sub_category_id: ticket.sub_category_id || '',
      ticket_type_id: ticket.ticket_type_id || '',
      assignee_user_id: ticket.assignee_user_id || '',
      priority_id: ticket.priority_id || '',
      status: ticket.status,
      statusRootId: ticket.parent_status_id || '',
      status_id: ticket.status_id || '',
      root_cause: ticket.root_cause || '',
      preventive_action: ticket.preventive_action || '',
      corrective_action: ticket.corrective_action || '',
      on_hold_description: isNil(ticket.on_hold_description) ? '' : ticket.on_hold_description,
      reopen_on: isNil(ticket.reopen_on) ? '' : new Date(ticket.reopen_on),
      problem_id: isNil(ticket.problem) ? null : ticket.problem.id,
      assigneeName: isNil(ticket.assignee) ? 'Not yet assigned' : '',
      currentProblem: isNil(ticket.problem) ? null : ticket.problem,
      customer_contract_id: ticket.customer_contract_id,
      client_id: ticket.client_id,
      service_id: ticket.service_id,
      service_type: ticket.service_type,
      primary_contact_email: ticket.primary_contact_email,
      contact_number: ticket.contact_number,
      client_contact_id: ticket.client_contact_id,
      disabledContactNotifications: ticket.disabledContactNotifications,
      service_categories: [],
      currentSubCategories: [],
      currentPriorities: [],
      errors: [],
      showMoreDescription: false,
      submitButtonClasses: 'button',
      submitButtonText: 'Update Ticket',
      problemStatus: 'loaded',
      client: {},
      statusIds,
      clientEscalation: ticket.clientEscalation,
      securityIssue: ticket.securityIssue
    }

    this.targetResponseTime = new Date(ticket.target_response_date)
    this.targetResolutionTime = new Date(ticket.target_resolution_date)
    this.firstResponseTime = !isEmpty(ticket.first_response_at) ? moment(new Date(ticket.first_response_at)).format('DD MMMM YYYY, hh:mmA') : 'Not yet responded to'
    this.datepickerMinDate = moment().add(1, 'days').toDate()
  }

  componentDidMount () {
    this.getRegion()
    this.getAssignee()
  }

  getAssignee () {
    const { ticket } = this.state
    if (isNil(ticket.assignee)) { return }

    cloudhelpGet(`/api/users/${ticket.assignee.id}`)
      .then((response) => {
        this.setState({ assigneeName: response.data.name })
      })
  }

  getRegion = () => {
    const { currentUser, ticket, ticket_statuses } = this.props
    if (!currentUser.calligo_employee) { return Promise.resolve() }

    cloudhelpGet(`/api/regions/${ticket.region_id || 'global'}.json`)
      .then((response) => {
        const region = response.data

        this.setState({
          priorities: _(region.priorities).map(priority => ({ value: priority.id, label: priority.name, key: priority.id })).sortBy('label').value(),
          ticketStatuses: _(ticket_statuses).map(status => ({
            value: status.value, label: status.label, key: status.value, root_id: status.root_id, inheritParentFields: status.inherit_parent_fields
          })).sortBy('label').value()
        })
      })
  }

  setFieldErrorClasses = (field) => {
    if (includes(this.state.fieldsWithErrors, field)) { return ('error') }
  }

  setField = (fieldName, value) => {
    this.setState({ [fieldName]: value })
  }

  handleSelectChange = (fieldName, selectedOption) => {
    const newState = {}

    newState[fieldName] = isNil(selectedOption) ? null : selectedOption.value
    newState.statusRootId = isNil(selectedOption.root_id) ? selectedOption.value : selectedOption.root_id

    this.setState(newState)
  }

  handleNestedSelectChange (selectedOption, currentListChange, getCurrentOptionsFunction, fieldName) {
    if (isNil(selectedOption)) { 
      this.setState({ [currentListChange]: [] }) 
    } else { 
      this.setState({ [currentListChange]: getCurrentOptionsFunction }) 
    }

    this.handleSelectChange(fieldName, selectedOption)
  }

  getCurrentListForSelect (list, key) {
    const currentList = map(list[key], i => ({ value: i.value, label: i.label, key: i.value }))

    return (currentList)
  }

  triggerShowEditModal = (event) => {
    event.preventDefault()

    this.setState({
      showEditModal: true
    })
  }

  submitForm = (e) => {
    e.preventDefault()
    const { ticket_types, updateAlert, updateTicket, assignCurrentUser } = this.props
    const {
      ticket,
      title,
      description,
      service_category_id,
      sub_category_id,
      ticket_type_id,
      priority_id,
      status_id,
      root_cause,
      preventive_action,
      corrective_action,
      on_hold_description,
      reopen_on,
      problem_id,
      clientEscalation,
      customer_contract_id,
      service_id,
      service_type,
      client_id,
      primary_contact_email,
      contact_number,
      client_contact_id,
      disabledContactNotifications,
      securityIssue
    } = this.state

    const patchData = {
      authenticity_token: csrfToken(),
      ticket: {
        title,
        description,
        customer_contract_id,
        service_id,
        service_type,
        service_category_id,
        sub_category_id,
        ticket_type_id,
        priority_id,
        status_id,
        root_cause,
        preventive_action,
        corrective_action,
        on_hold_description,
        reopen_on,
        client_escalation: clientEscalation,
        client_id,
        client_contact_id,
        primary_contact_email,
        contact_number,
        client_contact_id,
        disabled_contact_notifications: disabledContactNotifications,
        security_issue: securityIssue
      },
      problems_ticket: {
        problem_id
      },
      assignCurrentUser
    }

    this.setState({
      submitButtonText: 'Submitting',
      submitButtonClasses: 'button button--disabled'
    })

    axios.patch(`/tickets/${ticket.id}`, patchData)
      .then((response) => {
        const { ticket } = response.data
        this.setState({
          ticket,
          showEditModal: false,
          submitButtonText: 'Submitted successfully',
          submitButtonClasses: 'button'
        })

        updateTicket(ticket)
        updateAlert(true, 'success', 'Ticket has been successfully updated')
        window.location.href = response.data.redirect_url
      })
      .catch((error) => {
        const errorObject = error.response.data.errors[0]
        const errorText = error.response.status == 422 ? map(errorObject, (error, field) => (this.toErrorMessage(field, error))) : 'There was an issue assigning this problem.'

        this.setState({
          errors: errorText,
          fieldsWithErrors: Object.keys(errorObject),
          submitButtonText: 'Update Ticket',
          submitButtonClasses: 'button'
        })
      })
  }

  toErrorMessage (field, error) {
    let fieldName = capitalize(field)
    fieldName = replace(fieldName, /_id/g, '')
    fieldName = replace(fieldName, /_/g, ' ')

    return `${fieldName} ${error}`
  }

  isTicketStatus = (statusName) => {
    const { statusRootId, ticketStatuses, status_id } = this.state
    const { statusIds } = this.props

    return includes(statusIds[statusName], statusRootId) && get(find(ticketStatuses, ['value', status_id]), 'inheritParentFields', true)
  }

  ticketResolved = () => {
    const { statusRootId } = this.state
    const { statusIds } = this.props

    return includes(statusIds.resolved, statusRootId)
  }

  ticketInformationFields = () => {
    const { ticket, assigneeName, clientEscalation, securityIssue } = this.state
    const { currentUser } = this.props
    const {
      firstResponseTime,
      hasRole,
      isTicketStatus,
      ticketOnHoldFields,
      ticketResolvedFields,
      targetResponseTime,
      targetResolutionTime
    } = this

    const fieldsList = [
      {
        title: 'Created',
        content: moment(ticket.created_at).format('DD MMMM YYYY, hh:mmA')
      },
      currentUser.calligo_employee && {
        title: 'Target response time',
        content: `${moment(targetResponseTime).format('DD MMMM YYYY, hh:mmA')} (${ticket.target_response_time})`
      },
      (currentUser.calligo_employee && ticket.target_resolution_date) && {
        title: 'Target resolution time',
        content: `${moment(targetResolutionTime).format('DD MMMM YYYY, hh:mmA')} (${ticket?.target_resolution_time})`
      },
      currentUser.calligo_employee && {
        title: 'First response',
        content: firstResponseTime
      },
      {
        title: 'Category',
        content: ticket.service_category_name
      },
      {
        title: 'Ticket type',
        content: ticket.ticket_type_name
      },
      {
        title: 'Priority',
        content: ticket.priority_name
      },
      {
        title: 'Status',
        content: ticket.status_text
      },
      {
        title: 'Assignee',
        content: (
          <TextFieldSkeleton width="half" loading={isEmpty(assigneeName)}>
            {assigneeName}
          </TextFieldSkeleton>
        )
      }
    ]

    currentUser.calligo_employee && isTicketStatus('resolved') && fieldsList.push(ticketResolvedFields())
    currentUser.calligo_employee && isTicketStatus('onHold') && fieldsList.push(ticketOnHoldFields())

    currentUser.calligo_employee && isNull(ticket.primary_ticket_id) && hasRole('problem', 'attachTickets') && fieldsList.push({
      title: 'Associated problem',
      content: (
        !isEmpty(ticket.problem) ? (
          <a href={ticket.problem.href} className="link">
            {ticket.problem.issue}
          </a>
        ) : (
          <a href="javascript:;" className="link" onClick={() => { this.setState({ showEditModal: true }) }}>
            Attach a problem
          </a>
        )
      )
    })

    currentUser.calligo_employee && !isEmpty(ticket.associatedChangeRequests) && fieldsList.push({
      title: 'Associated Change Requests',
      content: (map(ticket.associatedChangeRequests, changeRequest => (
        <a href={changeRequest.href} target="_blank" rel="noopener noreferrer" className="link">
          {changeRequest.title}
        </a>
      )))
    })

    currentUser.calligo_employee && fieldsList.push({
      title: 'Tags',
      content: <Tags ticketID={ticket.id} />
    })

    fieldsList.push({
      title: 'Client Escalated?',
      content: clientEscalation ? 'Yes' : 'No'
    })

    fieldsList.push({
      title: 'Security Issue?',
      content: securityIssue ? 'Yes' : 'No'
    })

    return flatten(fieldsList)
  }

  ticketResolvedFields = () => {
    const { ticket } = this.state
    const resolvedAt = ticket.resolved_at ? moment(ticket.resolved_at).format('DD MMMM YYYY, hh:mmA') : 'No resolved date found'
    const fields = {
      'Root cause': ticket.root_cause,
      'Preventive action': ticket.preventive_action,
      'Corrective action': ticket.corrective_action,
      'Resolved at': resolvedAt
    }

    return map(fields, (value, name) => ({
      title: name,
      content: value
    }))
  }

  ticketOnHoldFields = () => {
    const { ticket } = this.state
    const fields = {
      'Why is this ticket on hold?': ticket.on_hold_description,
      'This ticket will re-open on': ticket.reopen_on
    }

    return map(fields, (value, name) => ({
      title: name,
      content: value
    }))
  }

  handleDateChange (dates, fieldName) {
    this.setState({
      [fieldName]: dates[0]
    })
  }

  removeProblem = (event) => {
    event.preventDefault()

    const { problemEndPoint } = this.props
    const { ticket } = this.state

    this.setState({
      problemStatus: 'loading'
    })

    axios.patch(problemEndPoint, {
      authenticity_token: csrfToken(),
      destroy: true,
      problem: { ticket_ids: [ticket.id] }
    })
      .then((response) => {
        this.setState({
          currentProblem: null,
          problem_id: null,
          problemStatus: 'loaded'
        })
      })
  }

  toggleShowMoreDescription = () => {
    this.setState({
      showMoreDescription: !this.state.showMoreDescription,
      problemStatus: 'loaded'
    })
  }

  handleInputChange (event, field) {
    const { target } = event
    const value = target.type === 'checkbox' ? target.checked : target.value

    this.setState({
      [field]: value
    })
  }

  hasRole = (...args) => {
    const { roles } = this.props

    return get(roles, args, false)
  }

  render () {
    const {
      assignee_user_id,
      assignees,
      root_cause,
      preventive_action,
      corrective_action,
      showMoreDescription,
      description,
      errors,
      on_hold_description,
      priority_id,
      priorities,
      problem_id,
      reopen_on,
      service_category_id,
      status_id,
      ticket,
      ticket_type_id,
      title,
      assigneeName,
      service_categories,
      sub_category_id,
      customer_contract_id,
      client_id,
      service_id,
      service_type,
      submitButtonText,
      submitButtonClasses,
      currentPriorities,
      currentProblem,
      currentSubCategories,
      problemStatus,
      ticketStatuses,
      showEditModal,
      serviceCategories,
      clientEscalation,
      isDescriptionOverflown,
      secondaryContactEmail,
      primary_contact_email,
      contact_number,
      client_contact_id,
      disabledContactNotifications,
      securityIssue
    } = this.state

    const {
      ticket_types,
      ticket_statuses,
      problems,
      currentUser,
      allServiceCategories,
      roles
    } = this.props

    const { client_id: originalClientId } = this.props.ticket

    const {
      triggerShowEditModal,
      hasRole,
      setFieldErrorClasses,
      handleSelectChange,
    } = this

    const filteredTicketTypes = filter(ticket_types, type => (isNil(type.ownerable_id) || type.name === 'User Management'))
    const ticketTypeOptions = map(filteredTicketTypes, type => ({ value: type.id, label: type.name, key: type.id }))
    const serviceCategoryOptions = map(
      filter(isEmpty(serviceCategories) ? allServiceCategories : serviceCategories, serviceCategory => isNil(serviceCategory.parent_id)),
      category => ({ value: category.id, label: category.name })
    )
    const subCategoriesOptions = map(
      filter(
        filter(serviceCategories, serviceCategory => !isNil(serviceCategory.parent_id)),
        { parent_id: service_category_id }
      ),
      category => ({ value: category.id, label: category.name })
    )

    const getCategoryValue = (id) => {
      const category = allServiceCategories.find(service => service.id === id) || {}

      return {
        label: category.friendly_name || category.name,
        value: category.id
      }
    }

    let contentSectionActions = []
    if (hasRole('ticket', 'update') && isNull(ticket.primary_ticket_id)) { 
      contentSectionActions.push({ text: 'edit', onClick: triggerShowEditModal })
    }

    return (
      <ContentSectionBlock title="Ticket information" actions={contentSectionActions}>
        {currentUser.calligo_employee && ticket.hasErrors && (
          <Alert title="Before updating this ticket, the following errors must be resolved">
            <ErrorList errors={ticket.errors} />
          </Alert>
        )}

        <TicketDescription description={ticket.description} />

        <DetailList list={this.ticketInformationFields()} />

        {currentUser.calligo_employee &&
          (
            <Modal
              showModal={showEditModal}
              title="Edit ticket information"
              removeModal={(event) => { this.setState({ showEditModal: false }) }}
            >
              <form onSubmit={event => (this.submitForm(event))}>
                {
                  !isEmpty(errors) && (
                    <Alert alertType="error">
                      <ErrorList errors={errors} />
                    </Alert>
                  )}
                <div className="row row--small-gutters row--bottom-spaced">
                  <div className="col">
                    <label htmlFor="ticket_title">
                      Title
                      <FormInputText
                        type="text"
                        id="ticket_title"
                        className={this.setFieldErrorClasses('title')}
                        name="ticket[title]"
                        value={title}
                        onValue={text => this.setState({ title: text })}
                      />
                    </label>
                  </div>
                </div>

                <div className="row row--small-gutters row--bottom-spaced">
                  <div className="col">
                    <label htmlFor="ticket_description">
                      Description
                      <FormInputTextArea
                        rows="3"
                        id="ticket_description"
                        className={this.setFieldErrorClasses('description')}
                        name="ticket[description]"
                        value={description}
                        onValue={text => this.setState({ description: text })}
                      />
                    </label>
                  </div>
                </div>

                {((client_id !== originalClientId || isNil(client_id)) || 
                  some([service_category_id, sub_category_id, customer_contract_id, service_id, service_type], isNil)
                ) && (
                  <ClientFormFields {...{ 
                    current_user: currentUser, 
                    setParentState: (newState) => this.setState(newState), 
                    ticket,
                    primary_contact_email,
                    contact_number,
                    client_id,
                    client_contact_id,
                    secondaryContactEmail,
                    disabledContactNotifications,
                  }} />
                )}

                <div className="row row--small-gutters row--bottom-spaced">
                  <div className="col col-12">
                    <label htmlFor="ticket_ticket_type">
                      Type
                    </label>
                    <Select
                      id="ticket_ticket_type_id"
                      className={this.setFieldErrorClasses('ticket_type')}
                      name="ticket[ticket_type_id]"
                      value={ticket_type_id}
                      onChange={option => this.handleSelectChange('ticket_type_id', option)}
                      clearable={false}
                      placeholder="-"
                      options={orderBy(ticketTypeOptions, 'label')}
                      isLoading={isEmpty(ticket_types)}
                    />
                  </div>

                  <div className="col col-12">
                    <label htmlFor="ticket_priority_id">
                      Priority
                    </label>
                    <Select
                      id="ticket_priority_id"
                      className={this.setFieldErrorClasses('priority_id')}
                      name="ticket[priority_id]"
                      value={priority_id}
                      onChange={option => (this.handleSelectChange('priority_id', option))}
                      clearable={false}
                      placeholder="-"
                      options={priorities}
                      isLoading={isEmpty(priorities)}
                    />
                  </div>
                </div>

                {!isNil(client_id) && (
                  <ServiceCategories {...{
                    clientId: client_id,
                    service_category_id,
                    sub_category_id,
                    customer_contract_id,
                    service_id,
                    service_type,
                    ticket_type_id,
                    handleSelectChange,
                    setFieldErrorClasses,
                    currentUser,
                  }} />
                )}

                {roles.ticket.clientEscalationEditor && (
                  <label className="flex mb-4 items-center">
                    <FormInputCheckbox
                      id={'clientEscalation'}
                      value={clientEscalation}
                      onValue={value => this.setState({ clientEscalation: value })}
                    />

                    <span className="mt-1">Client Escalated?</span>
                  </label>
                )}

                <label className="flex mb-4 items-center">
                  <FormInputCheckbox
                    value={securityIssue}
                    onValue={value => this.setState({ securityIssue: value })}
                  />

                  <span className="mt-1">Security Issue?</span>
                </label>

                <div className="row row--small-gutters row--bottom-spaced">
                  <div className="col">
                    <label htmlFor="ticket_status_id">
                      Status
                    </label>
                    <Select
                      id="ticket_status_id"
                      className={this.setFieldErrorClasses('status_id')}
                      name="ticket[status_id]"
                      value={status_id}
                      onChange={option => (this.handleSelectChange('status_id', option))}
                      placeholder="-"
                      clearable={false}
                      options={ticketStatuses}
                      isLoading={isEmpty(ticket_statuses)}
                    />
                  </div>
                </div>

                <div className="row row--small-gutters row--bottom-spaced" style={{ display: this.isTicketStatus('onHold') ? 'block' : 'none' }}>
                  <div className="col">
                    <label htmlFor="ticket_reopen_on">
                      When will this ticket re-open?
                      <FormInputDate
                        onValue={(date) => { this.setState({ reopen_on: date }) }}
                        enableTime={false}
                        // minDate={moment()}
                        value={reopen_on}
                        // errors={this.state.fieldsWithErrors.reopen_on}
                      />
                    </label>
                  </div>

                  <div className="col">
                    <label htmlFor="ticket_on_hold_description">
                      Why is this ticket being put on hold?
                      <FormInputTextArea
                        id="ticket_on_hold_description"
                        className={this.setFieldErrorClasses('on_hold_description')}
                        name="ticket[on_hold_description]"
                        value={on_hold_description}
                        onValue={text => this.setState({ on_hold_description: text })}
                      />
                    </label>
                  </div>
                </div>

                { this.isTicketStatus('resolved') && ticket_type_id !== 2 && (
                  <React.Fragment>
                    <div className="row row--small-gutters row--bottom-spaced">
                      <div className="col">
                        <label htmlFor="ticket_root_cause">
                          What was the root cause?
                        </label>
                        <FormInputText
                          id="ticket_root_cause"
                          value={root_cause}
                          onValue={text => this.setState({ root_cause: text })}
                          className={this.setFieldErrorClasses('root_cause')}
                        />
                      </div>
                    </div>

                    <div className="row row--small-gutters row--bottom-spaced">
                      <div className="col">
                        <label htmlFor="ticket_preventive_action">
                          What is the preventive action?
                        </label>
                        <FormInputText
                          id="ticket_preventive_action"
                          value={preventive_action}
                          onValue={text => this.setState({ preventive_action: text })}
                          className={this.setFieldErrorClasses('preventive_action')}
                        />
                      </div>
                    </div>

                    <div className="row row--small-gutters row--bottom-spaced">
                      <div className="col">
                        <label htmlFor="ticket_corrective_action">
                          How did you correct the issue?
                        </label>
                        <FormInputText
                          id="ticket_corrective_action"
                          value={corrective_action}
                          onValue={text => this.setState({ corrective_action: text })}
                          className={this.setFieldErrorClasses('corrective_action')}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                )}

                { this.props.problemViewer &&
                  (
                    <div className="row row--small-gutters">
                      <div className="col">
                        <label htmlFor="problems_ticket_problem_id">
                          Associated problem
                        </label>
                        { isEmpty(problems) && ('There are no existent problems') }

                        { isNull(currentProblem) && some(problems) &&
                          (
                            <Select
                              id="problems_ticket_problem_id"
                              className={this.setFieldErrorClasses('problem_id')}
                              name="problems_ticket[problem_id]"
                              value={problem_id}
                              onChange={option => (this.handleSelectChange('problem_id', option))}

                              placeholder="-"
                              options={problems}
                              isLoading={isEmpty(problems)}
                            />
                          )
                        }
                        {!isNull(currentProblem) && (
                          problemStatus === 'loaded'
                            ? (
                              <ul className="decorated-list">
                                <div>
                                  <li className="list--no-list-style">
                                    <span className="link">
                                      {`${ticket.problem.id} - ${ticket.problem.issue}`}
                                    </span>
                                    <button
                                      type="button"
                                      className="lnr lnr-trash2 lnr--hover-blue decorated-list__destroy"
                                      onClick={(e) => { this.removeProblem(e) }}
                                    />
                                  </li>
                                </div>
                              </ul>
                            ) : (<LoadingSpinner />)
                        )
                        }
                      </div>
                    </div>
                  )
                }

                <div className="form-section">
                  <div className="form-section__actions form-section__actions--space-between">
                    <button type="button" className="button button--secondary form-section__action" onClick={() => { this.setState({ showEditModal: false }) }}>
                      Cancel
                    </button>
                    <button name="commit" value={submitButtonText} className={submitButtonClasses} type="submit">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </Modal>
          )
        }
      </ContentSectionBlock>
    )
  }
}
